import React from 'react';
import { styled } from '@mui/material/styles';

// Google Fonts から BIZ UDPGothic を直接読み込み
const fontFaceStyle = `
  @font-face {
    font-family: 'BIZ UDPGothic';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/bizudpgothic/v14/hES36X5pHAIBjmS84VL0Bue83nU.ttf) format('truetype');
  }
`;

// スタイルを head に追加（一度だけ）
if (typeof document !== 'undefined' && !document.querySelector('#biz-udp-gothic-font-roman')) {
  const styleElement = document.createElement('style');
  styleElement.id = 'biz-udp-gothic-font-roman';
  styleElement.textContent = fontFaceStyle;
  document.head.appendChild(styleElement);
}

// スタイル付きのspanコンポーネントを作成
const RomanSpan = styled('span')({
  fontFamily: '"BIZ UDPGothic", "Noto Sans JP", sans-serif',
  fontFeatureSettings: '"jp90" 1', // 「ひげ付き」スタイルを有効化
});

const RomanNumeralText = ({ text }) => {
  // 正規表現で(Ⅰ), (Ⅱ), (Ⅲ)などを検出
  const parts = text.split(/(\([ⅠⅡⅢ]+\))/);
  
  return (
    <>
      {parts.map((part, index) => {
        if (part.match(/^\([ⅠⅡⅢ]+\)$/)) {
          // 括弧付きローマ数字の場合、BIZ UDPGothicフォントを適用
          return <RomanSpan key={index}>{part}</RomanSpan>;
        }
        return <span key={index}>{part}</span>;
      })}
    </>
  );
};

export default RomanNumeralText;
